import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { DashboardRoutes } from "./DashboardRoutes";
import { LoadingProvider } from "../contexts/LoadingContext";
import { ThemeProvider } from "styled-components";
import { useTheme } from "../contexts/ThemeContext";
import { SidebarProvider } from "../contexts/SidebarContext";
import { SearchProvider } from "../contexts/PlayerSearchContext";
import { NotificationProvider } from "../contexts/NotificationContext";
import { ClubSearchProvider } from "../contexts/ClubSearchContext";
import { ModalProvider } from "styled-react-modal";
import Login from "../pages/Login";
import ProtectedRoute from "./ProtectedRoute";
import { AuthProvider } from "../contexts/AuthContext";
import Layout from "../components/Layout";
import { PlayerSearchProvider } from "../contexts/SearchPlayersContext";
import { PitchWidgetContextProvider } from "../contexts/PitchWidgetContext";
import { SquadSystemFitContextProvider } from "../contexts/SquadSystemFitContext";
import ScrollToTop from "./ScrollToTop";
import Analytics from "./Analytics";
import { NewPlayerShortlistContextProvider } from "../contexts/NewPlayerShortlistContext";
import { SwapHistoryProvider } from "../contexts/SwapHistoryContext";
import SignUpPage from "../pages/SignUp";
import ForgotPwd from "../pages/ForgotPwd";
import ChangePassowrd from "../pages/ChangePwd";
import VerifyEmail from "../pages/VerifyEmail";
import GrantAccessPage from "../pages/GrantAccessPage";
import PitchWidget from "../PitchWidget";
import PlayerCard from "../PlayerCardWidget";
import Preview from "../pages/Preview";

export const AppRouter: React.FC = () => {
  const { theme } = useTheme();

  return (
    <ThemeProvider theme={theme}>
      <NotificationProvider>
        <SidebarProvider>
          <LoadingProvider>
            <ModalProvider>
              <SearchProvider>
                <PlayerSearchProvider>
                  <ClubSearchProvider>
                    <PitchWidgetContextProvider>
                      <SquadSystemFitContextProvider>
                        <NewPlayerShortlistContextProvider>
                          <SwapHistoryProvider>
                            <Router>
                              <Analytics />
                              <AuthProvider>
                                <ScrollToTop />
                                <Routes>
                                  <Route path="/login" element={<Login />} />
                                  <Route path="/signup" element={<SignUpPage/>}/>
                                  <Route path="/forgotpassword" element={<ForgotPwd/>}/>
                                  <Route path="/changepassword" element={<ChangePassowrd/>}/>
                                  <Route path="/verifyemail" element={<VerifyEmail/>}/>
                                  <Route path="/GrantAccess" element={<GrantAccessPage/>}/>
                                  <Route path="/player-widget" element={<PlayerCard />} />
                                  <Route path="/pitch-widget" element={<PitchWidget />} />
                                  <Route path="/preview" element={<Preview />} />
                                  {/* <Route path="/pitch" element={<WidgetPage />} /> */}
                                  <Route
                                    path="/*"
                                    element={
                                      <ProtectedRoute>
                                        <Layout>
                                          <DashboardRoutes />
                                        </Layout>
                                      </ProtectedRoute>
                                    }
                                  />
                                </Routes>
                              </AuthProvider>
                            </Router>
                          </SwapHistoryProvider>
                        </NewPlayerShortlistContextProvider>
                      </SquadSystemFitContextProvider>
                    </PitchWidgetContextProvider>
                  </ClubSearchProvider>
                </PlayerSearchProvider>
              </SearchProvider>
            </ModalProvider>
          </LoadingProvider>
        </SidebarProvider>
      </NotificationProvider>
    </ThemeProvider>
  );
};
